import EtablissementAlias from '@/generated/controls/etablissement/EtablissementAlias.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementAlias
})
